const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>How does Cryptocurrency CFD trading work?</h1>
        <p>
          Bitcoin is a digital cryptocurrency that derives its value from unique
          supply and demand factors. It is available in a finite supply and
          increases in price as demand increases.
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
